import { Fonts } from '@pff-consumer/core-ui'
import type { FontWeight, FontStyle } from '@pff-consumer/core-ui'
import type { Styles } from 'react-jss'

export const getFontStyles = (family: Fonts, weight: FontWeight = '400', style: FontStyle = 'normal'): Styles => {
  return {
    fontFamily: family,
    fontWeight: weight,
    fontStyle: style,
  }
}
